document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-product-gallery-thumb]');
  if (!thumbnail) return;

  const gallery = thumbnail.closest('[data-product-gallery]');
  const activeImage = gallery?.querySelector('[data-product-gallery-active]');
  if (!activeImage) return;

  activeImage.src = thumbnail.dataset.gallerySrc;
  activeImage.srcset = thumbnail.dataset.gallerySrcset || '';
  activeImage.sizes = thumbnail.dataset.gallerySizes || '';
  activeImage.alt = thumbnail.dataset.galleryAlt || '';

  gallery.querySelectorAll('[data-product-gallery-thumb]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button === thumbnail));
  });

  const status = gallery.querySelector('[data-product-gallery-status]');
  const thumbnails = [...gallery.querySelectorAll('[data-product-gallery-thumb]')];
  if (status) status.textContent = `Image ${thumbnails.indexOf(thumbnail) + 1} of ${thumbnails.length}`;
});
